<template>
    <div class="tab-pane fade" id="nav-Coaching" role="tabpanel" aria-labelledby="nav-Coaching-tab" tabindex="0">
        <div class="table-responsive dashboard-table-responsive">
            <table class="table dashboard-card-table">
                <tbody>
                    <tr v-for="record in Booking_Coaching" :key="record.id">
                        <td>
                            <div class="academy-info">
                                <router-link to="/user/user-bookings" class="academy-img">
                                    <img :src="require(`@/assets/img/featured/${record.Image}`)" alt="Booking" />
                                </router-link>
                                <div class="academy-content">
                                    <h6 class="mb-1">
                                        <a data-bs-toggle="modal" data-bs-target="#upcoming-coach">{{
                                            record.Name
                                        }}</a>
                                    </h6>
                                    <span class="mb-0">{{ record.Topic }}</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <h6>Date & Time</h6>
                            <p>{{ record.Date }}</p>
                            <p>{{ record.Time }}</p>
                        </td>
                        <td>
                            <h4>{{ record.Amount }}</h4>
                        </td>
                        <td>
                            <div class="dropdown dropdown-action">
                                <a href="javascript:void(0);" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                                    aria-expanded="false"><i class="fas fa-ellipsis"></i></a>
                                <div class="dropdown-menu dropdown-menu-end">
                                    <a class="dropdown-item" href="javascript:void(0);">
                                        <i class="feather-x-circle"></i> Cancel
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import Booking_Coaching from "@/assets/json/coach-mybooking-coaching.json";
export default {
    data() {
        return {
            Booking_Coaching: Booking_Coaching,
        };
    },
};
</script>
  